import type {
  PassengerCounts,
  Trip,
  Nationality,
  PassengerCategory,
  PassengerKey,
} from "@/types/trip";

export const JETTIES = [
  "Mersing",
  "Tanjung Gemok",
  "Tekek (Tioman)",
  "ABC (Tioman)",
  "Salang (Tioman)",
  "Genting (Tioman)",
  "Paya (Tioman)",
] as const;

export const DEPARTURE_TRIPS: Trip[] = [
  { id: "dep-0800", time: "08:00 AM", status: "available" },
  { id: "dep-1100", time: "11:00 AM", status: "fully-booked" },
];

export const RETURN_TRIPS: Trip[] = [
  { id: "ret-1000", time: "10:00 AM", status: "fully-booked" },
  { id: "ret-1300", time: "01:00 PM", status: "available" },
];

export const NATIONALITIES: Nationality[] = ["Malaysian", "Foreigner"];

export const PASSENGER_CATEGORIES: PassengerCategory[] = [
  "Adult",
  "Child",
  "Infant",
];

export const MAX_PER_CATEGORY = 9;

export const PASSENGER_KEYS: PassengerKey[] = NATIONALITIES.flatMap(
  (nationality) =>
    PASSENGER_CATEGORIES.map(
      (category) => `${nationality}-${category}` as PassengerKey,
    ),
);

export const PASSENGER_FARES: Record<PassengerKey, number> = {
  "Malaysian-Adult": 60,
  "Malaysian-Child": 60,
  "Malaysian-Infant": 60,
  "Foreigner-Adult": 60,
  "Foreigner-Child": 60,
  "Foreigner-Infant": 60,
};

export type InventoryBalance = { label: string; count: number };

export type InventoryRoute = {
  label: string;
  origin: string;
  destination: string;
  balances: InventoryBalance[];
};

const DEFAULT_BALANCES: InventoryBalance[] = [
  { label: "Adult (Malaysian)", count: 50 },
  { label: "Child (Malaysian)", count: 50 },
  { label: "Adult (Foreigner)", count: 50 },
  { label: "Child (Foreigner)", count: 50 },
];

export const INVENTORY_ROUTES: InventoryRoute[] = [
  {
    label: "mersing-north",
    origin: "Mersing",
    destination: "Tekek, ABC, Salang, Genting, Paya",
    balances: DEFAULT_BALANCES,
  },
  {
    label: "mersing-south",
    origin: "Mersing",
    destination: "Juara, Mukut",
    balances: DEFAULT_BALANCES,
  },
  {
    label: "gemuk-north",
    origin: "T.Gemuk",
    destination: "Tekek, ABC, Salang, Genting, Paya",
    balances: DEFAULT_BALANCES,
  },
  {
    label: "gemuk-south",
    origin: "T.Gemuk",
    destination: "Juara, Mukut",
    balances: DEFAULT_BALANCES,
  },
];

export type PriceLine = {
  key: PassengerKey;
  label: string;
  nationality: Nationality;
  qty: number;
  amount: number;
};

export const buildPriceLines = (counts: PassengerCounts): PriceLine[] =>
  PASSENGER_KEYS.filter((key) => counts[key] > 0).map((key) => {
    const [nationality, category] = key.split("-") as [
      Nationality,
      PassengerCategory,
    ];
    return {
      key,
      label: `${category} (${nationality})`,
      nationality,
      qty: counts[key],
      amount: counts[key] * PASSENGER_FARES[key],
    };
  });

export const grandTotal = (counts: PassengerCounts): number =>
  buildPriceLines(counts).reduce((total, line) => total + line.amount, 0);
